import api from './api';
import { supabase } from '../supabaseClient'; // Importamos o cliente Supabase para acessar o Storage

// --- Funções que falam com o NOSSO BACKEND ---
const createService = async (serviceData) => {
  const { data } = await api.post('/service', serviceData);
  return data;
};

const getServices = async () => {
  const { data } = await api.get('/service');
  return data;
};

const updateService = async (id, serviceData) => {
  const { data } = await api.put(`/service/${id}`, serviceData);
  return data;
};

const deleteService = async (id) => {
  const { data } = await api.delete(`/service/${id}`);
  return data;
};

// --- NOVA FUNÇÃO que fala com o SUPABASE STORAGE ---
// frontend/src/services/serviceService.js

// --- NOVA FUNÇÃO que fala com o SUPABASE STORAGE ---
// const uploadServiceImage = async (file) => {
//   // Pega o usuário logado para criar um caminho de arquivo seguro e único
//   const { data: { user } } = await supabase.auth.getUser();
//   if (!user) throw new Error("Usuário não autenticado para fazer upload.");

//   // --- CORREÇÃO APLICADA AQUI ---
//   // Limpa o nome do arquivo para remover espaços e caracteres especiais.
//   const cleanFileName = file.name.replace(/\s/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');
//   const fileName = `${Date.now()}_${cleanFileName}`;
//   // -----------------------------

//   const filePath = `${user.id}/${fileName}`;

//   // Faz o upload para o bucket 'imagens-servicos'
//   const { data: uploadData, error: uploadError } = await supabase.storage
//     .from('imagem')
//     .upload(filePath, file);

//   if (uploadError) {
//     // Lança o erro do Supabase para que possamos vê-lo no console
//     throw uploadError;
//   }

//   // Se o upload deu certo, pega a URL pública do arquivo para salvar no banco
//   const { data: urlData } = supabase.storage
//     .from('imagem')
//     .getPublicUrl(uploadData.path);

//   return urlData.publicUrl;
// };

const uploadServiceImage = async (file) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) throw new Error("Usuário não autenticado");

    console.log('Usuário:', user.id);
    console.log('Arquivo:', file.name, file.size);

    const cleanFileName = file.name.replace(/\s/g, '_').replace(/[^a-zA-Z0-9.\-_]/g, '');
    const fileName = `${Date.now()}_${cleanFileName}`;
    const filePath = `${user.id}/${fileName}`;

    console.log('Fazendo upload para:', filePath);

    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('imagem')
      .upload(filePath, file);

    if (uploadError) {
      console.error('Erro no UPLOAD:', uploadError);
      throw uploadError;
    }

    console.log('Upload realizado com sucesso:', uploadData);

    const { data: urlData } = supabase.storage
      .from('imagem')
      .getPublicUrl(uploadData.path);

    console.log('URL pública:', urlData.publicUrl);
    return urlData.publicUrl;

  } catch (error) {
    console.error('Erro completo no upload:', error);
    throw error;
  }
};

// --- EXPORTAÇÃO DE TODAS AS FUNÇÕES ---
const serviceService = {
  createService,
  getServices,
  updateService,
  deleteService,
  uploadServiceImage, // Adicionamos a nova função
};

export default serviceService;